import { useAppSelector } from '../../../hook/useAppSelector';
import { formatNumberWithSpace } from '../../../util/format-number';
import { getMoneyClass } from '../../../util/formatCurrencySymbol';

interface MoneyRowProps {
  label: string;
  amount: number;
  className?: string;
}
const MoneyRow: React.FC<MoneyRowProps> = ({ label, amount, className }) => {
  const selectedCCY = useAppSelector((state) => state.cashRegisterData.selectedCCY);

  return (
    <div className={`value_row ${className}`}>
      <span className="label">{label}</span>
      <span className={`money_container ${getMoneyClass(selectedCCY)}`}>
        <span className="balance">{formatNumberWithSpace(amount)}</span>
        <span className="currency"> {selectedCCY}</span>
      </span>
    </div>
  );
};

export default MoneyRow;
